<template>
  <div>
    <!-- <TheNavigationPanel/> -->
    <div  :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}"> 
    <v-container>
      <v-toolbar flat color="#F0FFEA" height="30">
          <v-toolbar-title style="color:#62AE32" class="headline">Community</v-toolbar-title>
      </v-toolbar>
      <v-toolbar flat color="#F0FFEA">
          <v-spacer></v-spacer>
          <v-btn large color="#08911B" class="pa-2" dark style="border-radius:20PX" to="/community/addCommunity"> 
              <v-icon>mdi-plus</v-icon>
              <span>Add Community</span>
          </v-btn>
      </v-toolbar>
      <v-card>
        <template>
          <v-data-table
              :headers="headers"
              :items="Community"
              :class="elevation-1"
              class="mt-5 px-5"
              :items-per-page="5"
              :search="search"
              no-data-text="No Community To Display"
              >
              <template  v-slot:top>
                  <v-toolbar flat color="white">
                      <v-spacer></v-spacer>
                      <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                          color="#08911B"
                          style="width:20%"
                      ></v-text-field>
                  </v-toolbar>
              </template>
              <template v-slot:item.action="{ item }"> 
                <v-icon
                  small
                  style="color:#B45C5C; cursor: pointer;"
                   @click="editName(item.community_id)"
                  >
                  mdi-pencil
                </v-icon> 
                <v-icon
                  style="color:#B45C5C; cursor: pointer;"
                   @click="getName(item.community_id)"
                  >
                  mdi-chevron-right
                </v-icon> 
                  
              </template>

          </v-data-table>
      </template>
      </v-card>
    </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'community',
  components: {
  },
  data: () => ({
      search:'',
    headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'community_name',
          class:'font-weight-black'
        },
        {text: 'No Of Members', value:'no_of_members'},
        {text:'Community Code', value:'community_code'},
        { text: '', value: 'action', sortable: false },
    ],
    transactions:[
        {name:'ASTRA POLARIS', membersCount:'100', communityId:'UBA-009'},
        {name:'PROVIDUS BANK', membersCount:'100', communityId:'UBA-009'},
        {name:'UBA', membersCount:'100', communityId:'UBA-009'},
        {name:'PROVIDENCE', membersCount:'100', communityId:'UBA-009'},
        {name:'FIRST BANK', membersCount:'100', communityId:'UBA-009'},
    ]
  }),
  computed:{
    Community(){
        return this.$store.state.community.community
      },
  },
  methods:{ 
      getName(id){
      this.$store.dispatch("CommunityById", id)
      .then(()=>{
        this.$router.push('/community/members')
      })
      .catch(()=>{
      })
    },
    editName(id){
      this.$store.dispatch("CommunityById", id)
      .then(()=>{
        this.$router.push('/community/editCommunity')
      })
      .catch(()=>{
      })
    }     
  },
  created(){
    this.$store.dispatch("getCommunity")
      .then(()=>{
      })
      .catch(()=>{
      });
  }
};
</script>
<style  scoped>
  #item{
    background-color:#F0FFEA !important;
    min-height:100vh;
  }
</style>